import connection from './connection.js'

const getPaySetting = async function (params,callback) {
  const url = '/admin/config/list'
  let { error, data } = await connection.query(url,params)
  if (callback) callback(error, data)
}

const paySettingUpdate = async function (params, callback) {
  const url = '/admin/config/update'
  let { error, data } = await connection.update(url, params)
  if (callback) callback(error, data)
}

export { getPaySetting, paySettingUpdate }
